const useScroll = (ref, block = 'center') => {
    const handleClick = () => {
        ref.current.scrollIntoView(true)
    }

    return handleClick
}

export default useScroll
